import React, { useState, useEffect, useRef } from "react";
import "./index.scss";

import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import BlogService from "../../../services/blog/blog.service";
import { showErrorToaster } from "../../../components/toaster/error";
import { showSuccessToaster } from "../../../components/toaster/success";

const blogService = new BlogService();

const BlogForm = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Utiliser l'ID de la réalisation pour récupérer les données
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    date: "",
    image: "",
  });
  console.log(formData);
  const [imagePreview, setImagePreview] = useState(null); // Pour l'aperçu de l'image
  const [error, setError] = useState("");
  const [data, setJobList] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  // Charger les catégories pour le menu déroulant

  useEffect(() => {
    if (id) {
      // Si un ID est présent, on charge les données existantes pour l'édition
      const fetchBlog = async () => {
        try {
          const response = await blogService.getBlogById(id);
          setFormData(response.data);
          setImagePreview(response.data.image); // Si une image existe, l'afficher
        } catch (error) {
          showErrorToaster("Erreur lors du chargement des données.");
        }
      };
      fetchBlog();
    }
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0]; // Récupère le fichier sélectionné
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file, // Met à jour l'image dans l'état
      }));
      setImagePreview(URL.createObjectURL(file)); // Met à jour l'aperçu de l'image
    }
  };
  const handleChange1 = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      description: value, // on met directement la valeur de l'éditeur dans "description"
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setJobList([...data, formData]);

    if (
      !formData.title ||
      !formData.description ||
      !formData.date ||
      !formData.image
    ) {
      setError("Veuillez remplir tous les champs.");
      return;
    }

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("date", formData.date);
      formDataToSend.append("image", formData.image);

      if (id) {
        // Si un ID est présent, on modifie la réalisation existante
        await blogService.updateBlog(id, formDataToSend);
        showSuccessToaster("Modification réussie.");
      } else {
        // Sinon, on crée une nouvelle réalisation
        await blogService.createBlog(formDataToSend);
        showSuccessToaster("Création réussie.");
      }
      navigate("/blog-liste");
    } catch (error) {
      showErrorToaster(
        error.response
          ? error.response.data.message
          : "Une erreur est survenue, veuillez réessayer."
      );
    }
  };
  const toolbarOptions = [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["bold", "italic", "underline"],
    [{ align: [] }],
    ["link", "image"],
  ];
  return (
    <div className="job-form-container">
      <h1>{id ? "Modifier l'actualité" : "Créer une actualité"}</h1>
      <form onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}
        <div className="form-group">
          <label>Titre:</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <label>Description:</label>

          <ReactQuill
            theme="snow"
            value={formData.description}
            onChange={handleChange1} // Appelle handleChange avec la nouvelle valeur
            modules={{
              toolbar: {
                container: toolbarOptions, // Utilisation de la barre d'outils définie ci-dessus
              },
            }}
          />
        </div>
        <div className="form-group">
          <label>Date:</label>
          <input
            type="date"
            name="date"
            value={formData.date ? formData.date.split("T")[0] : ""} // Corrige le format
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Image:</label>
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleImageChange}
          />

          <p>
            {formData?.image
              ? formData.image.name
              : "Aucune image sélectionnée"}
          </p>
        </div>

        <button type="submit" className="submit-button">
          {id ? "Modifier" : "Créer"}
        </button>
      </form>
    </div>
  );
};

export default BlogForm;
